import { Component, EventEmitter, Input, OnInit, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Button, Categories, LabelsName, RoutePath } from '../../../../../shared/model/enum';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { AddEditConsignmentComponent } from '../add-edit-consignment/add-edit-consignment.component';
import { AddEditInventoryComponent } from "../add-edit-inventory/add-edit-inventory.component";
import { AddEditManufacturerComponent } from '../../../../admin/look-up-tables/pop-ups/multi-level-list-popups/add-edit-manufacturer/add-edit-manufacturer.component';
import { SearchService } from '../../../../../shared/services/search.service';
import { WindowSizeService } from '../../../../../shared/services/window-resize.service';
import { PartsListService } from '../../pages/parts-list/parts-list.service';
import Swal from 'sweetalert2'
import { FilterCheckList } from '../../../../crm/companies/pages/companies/companies.model';
import { Router } from '@angular/router';
import { TabsService } from '../../../../../shared/components/tabs/tabs.service';
export const partInventoryEvent = new EventEmitter<void>();
@Component({
  selector: 'app-add-edit-part',
  templateUrl: './add-edit-part.component.html',
  styleUrls: ['./add-edit-part.component.scss']
})
export class AddEditPartComponent extends SearchService implements OnInit {
  title: any;
  formModel: any = {}
  @Input() data: any = {}
  getAllDropdown: any = {}
  filterCheckList = new FilterCheckList();
  width!: number;
  enumButtonName = Button;
  active = 1;
  submitted: boolean = false;
  enumFilterLabel = LabelsName;
  mfrName: any
  tabData = [
    { id: 1, label: 'Compliance & Export', },
    { id: 2, label: ' Additional Details', },
    { id: 3, label: 'Pricing', },
  ]
  constructor(public activeModal: NgbActiveModal, public toaster: ToastrService,
    public renderer: Renderer2,
    public sendDataService: SendDataService,
    private windowSizeService: WindowSizeService,
    public partsListService: PartsListService,
    private router: Router,
    public tabsService: TabsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getById()
    this.windowSizeService.getScreenWidth().subscribe((res) => {
      this.width = res;
    });
    this.partsListService.allPartDropdownList().subscribe((res) => {
      if (res.isSuccess) {
        this.getAllDropdown = res?.response;
        this.getDropdownList()
      }
    });
  }
  getDropdownList() {
    if (this.title == 'Edit Part' || this.data?.clone) {
      this.getAllDropdown?.roHSList?.map((gs) => {
        this.formModel?.complianceExportModel?.rohsId?.map((value) => {
          if (gs.id == value.id) {
            gs.isActive = value.isActive;
          }
        });
      });
      this.getAllDropdown?.countryList?.map((gs) => {
        this.formModel?.complianceExportModel?.cooId?.map((value) => {
          if (gs.id == value.id) {
            gs.isActive = value.isActive;
          }
        });
      });

      const tagIds = this.formModel?.complianceExportModel?.tagId?.map(tag => tag?.id) ?? [];
      this.getAllDropdown?.partTagsList?.forEach(x => x.selectedTags = tagIds?.includes(x.id));
      this.getByCategoryId(Categories?.CATEGORY_GROUPID, this.formModel?.complianceExportModel?.categoryGroupId, this.enumFilterLabel?.CATEGORY_GROUP)
      this.getByCategoryId(Categories?.PARENT_CATEGORY_GROUPID, this.formModel?.complianceExportModel?.parentCategoryId, this.enumFilterLabel?.PARENT_CATEGORY)
      this.getByCategoryId(Categories?.CATEGORY_ID, this.formModel?.complianceExportModel?.categoryId, this.enumFilterLabel?.CATEGORY)
    }
  }
  getByCategoryId(request, id, label) {
    if (!id) return
    this.partsListService.getInventoryCategoryDropdownById(request, id).subscribe((res) => {
      if (res) {
        switch (label) {
          case this.enumFilterLabel?.CATEGORY_GROUP:
            this.getAllDropdown.parentCategoryGroupList = res?.response?.list
            break
          case this.enumFilterLabel?.PARENT_CATEGORY:
            this.getAllDropdown.inventoryCategoryList = res?.response?.list
            break
          case this.enumFilterLabel?.CATEGORY:
            this.getAllDropdown.subCategoryList = res?.response?.list
            break
        }
      }
    })
  }

  getById() {
    if (this.title == 'Edit Part' || this.data?.clone) {
      let id = this.data?.clone ? this.data?.selectedId : this.partsListService.id;
      this.partsListService.getPartDetailById(id).subscribe((res) => {
        if (res) {
          this.formModel = res?.response;
          this.filterCheckList.rohs_CheckList = this.formModel?.complianceExportModel?.rohsId?.map((value) => value.name);
          this.filterCheckList.coo_CheckList = this.formModel?.complianceExportModel?.cooId?.map((value) => value.name);
          if (!this.formModel?.manufacturerId) return
          this.selectValueChange(this.formModel?.dropdownManufacturerName, this.formModel.manufacturerId)
          this.formModel.manufacturerId = this.formModel?.manufacturerId;
        }
      })
    }
  }

  openAddEditMFRModal() {
    const data = {}
    this.sendDataService.openModalPopup(AddEditManufacturerComponent, data, 'Add', ModalPopupSize.MD, 'has-parent-popup').then(
      (resultData) => {
        if (resultData?.isSuccess) {
          this.partsListService.allPartDropdownList().subscribe((res) => {
            this.getAllDropdown = res?.response;
            this.formModel.manufacturerId = resultData?.response?.id;
            this.mfrName = resultData?.response?.response?.name;
            this.selectValueChange(this.mfrName, resultData?.response?.response?.id);
          });
        }
      }
    );

  }
  // for input keydown ------------------
  onKeydown(event: any, value: any) {
    const element = this.renderer.selectRootElement(value, true);
    if (event.key === "Enter") {
      element.focus();
    }
  }
  activeTab(id) {
    this.active = id;
  }
  isDisable() {
    return this.formModel?.manufacturerPartNumber && this.formModel?.manufacturerId
  }
  openAddInventoryPopup1() {
    if (this.sendDataService.popupIsOpen) {
      Swal.fire({
        title: 'Add Inventory popup is already open!',
        text: 'Do you want to close the existing popup and open a new one?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          popup: 'swal-small-popup',
          htmlContainer: 'swal-small-text',
          confirmButton: 'swal-small-confirm',
          cancelButton: 'swal-small-cancel',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendDataService.closeModal(AddEditInventoryComponent);
          this.sendDataService.popupIsOpen = false;
          // this.openNewInventoryPopup();
        }
      });
      return;
    }
  }

  openAddInventoryPopup() {
    const call = this.title === 'Edit Part' ? this.updatePart() : this.onAddPartButtonClick();
    Promise.resolve(call).then((result) => {
      this.sendDataService.popupIsOpen = true
      const data = {
        disableField: false,
        selectedData: {
          mpn: this.formModel?.manufacturerPartNumber,
          mfr: this.mfrName,
          id: result?.id || result?.mpnId || this.formModel?.mpnId,
          mfrId: this.formModel?.manufacturerId,
        },
      };
      this.sendDataService.openModalPopup(AddEditInventoryComponent, data, 'Add Inventory', ModalPopupSize.LG, 'add-part-popup')
        .then((resultData) => {
          if (resultData && resultData.success) {
            this.sendDataService.popupIsOpen = false
          }
        });
    });
  }

  openAddConsignmentPopup() {
    const call = this.title === 'Edit Part' ? this.updatePart() : this.onAddPartButtonClick();
    Promise.resolve(call).then((result) => {
      const data = {
        disableField: false,
        selectedData: {
          mpn: this.formModel?.manufacturerPartNumber,
          mfr: this.mfrName,
          id: result?.id || result?.mpnId || this.formModel?.mpnId,
          mfrId: this.formModel?.manufacturerId,
        },
      };
      this.sendDataService.openModalPopup(AddEditConsignmentComponent, data, 'Add Consignment', ModalPopupSize.LG, 'add-part-popup').then(
        (resultData) => {
          if (resultData) {
            if (resultData.success) {

            }
          }
        }
      );
    });
  }

  selectValueChange(event: string, id) {
    this.mfrName = event || null;
    this.formModel.manufacturerId = id ?? null;

    if (event === 'No Records Found') {
      this.mfrName = '';
      this.formModel.manufacturerId = null;
      return;
    }
    if (event) {
      if (this.getAllDropdown?.masterManufacturerWithChildrenList) {
        const matchingMfr = this.getAllDropdown?.masterManufacturerWithChildrenList?.find(
          (x) => x.name.trim().toLowerCase() === event.trim().toLowerCase()
        );
        this.formModel.manufacturerId = matchingMfr?.id || null;
      }
    }
  }

  clearInputText() {
    const matchingMfr = this.getAllDropdown?.masterManufacturerWithChildrenList?.find((x) => x.name.trim().toLowerCase() === this.formModel.manufacturerId?.trim().toLowerCase());

    if (matchingMfr) {
      this.mfrName = matchingMfr.name;
      this.formModel.manufacturerId = matchingMfr.id;
      return;
    }

    if (!this.getAllDropdown?.masterManufacturerWithChildrenList?.some((x) => x.name.trim().toLowerCase() === this.mfrName?.trim().toLowerCase())) {
      this.mfrName = '';
      this.formModel.manufacturerId = '';
    }
  }


  onAddPartButtonClick(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.data?.clone) { this.formModel.id = '' }
      const requestModel = { ...this.formModel };
      ["complianceExportModel", "additionalDetailsModel", "pricingModel"].forEach((model) => {
        if (!Object.keys(requestModel[model] || {}).length) {
          delete requestModel[model];
        }
      });

      this.partsListService.insertParts(requestModel).subscribe(
        (res) => {
          if (res?.isSuccess) {
            this.toaster.success(res?.message);
            if (this.router?.url?.includes(RoutePath.PARTLISTINFO_ROUTEPATH)) {
              partInventoryEvent.emit();
            }
            this.activeModal.close({ response: res, title: 'Add Part', confirm: true });
            resolve(res.response || res);
          } else {
            reject();
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  updatePart(): Promise<void> {
    return new Promise((resolve, reject) => {
      const requestModel = { ...this.formModel };
      ["complianceExportModel", "additionalDetailsModel", "pricingModel"].forEach((model) => {
        if (!Object.keys(requestModel[model] || {}).length) {
          delete requestModel[model];
        }
      });

      this.partsListService.updateParts(requestModel).subscribe(
        (res) => {
          if (res?.isSuccess) {
            this.toaster.success(res?.message);
            if (this.router?.url?.includes(RoutePath.PARTLISTINFO_ROUTEPATH)) {
              partInventoryEvent.emit();
              this.tabsService.updateName({ id: res?.response?.id, title: res?.response?.manufacturerPartNumber })
            }
            this.activeModal.close({ response: res, title: 'Edit Part', confirm: true });
            resolve();
          } else {
            reject();
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

}
